
/// <reference types="vite/client" />


export async function fetchCategories() {
    const env: any = import.meta.env;
    const url = `${env.VITE_API_URL}/${env.VITE_ATTRIBUTES_ENDPOINT}`;
    const options = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            isCategory: true
        })
    };

    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (!data?.attributes) throw Error("No attributes found in response");
        const mappedData = data.attributes.map((attribute: any) => {
            if (!attribute.fields) return;
            const attributeFields = attribute.fields.map((field: any) => {
                if (field.customData) {
                    if (field.customData.fieldVisibility) {
                        return {
                            ...field,
                            fieldVisibility: field.customData.fieldVisibility
                        }
                    } else {
                        return field;
                    }
                } else {
                    return field;
                }
            })
            return {
                ...attribute,
                fields: attributeFields
            }
        });
        return mappedData;
    } catch (error: any) {
        console.error(error);
        throw error;
    }
}

export async function fetchProjects(keyword?: string) {
    const env: any = import.meta.env;
    const url = `${env.VITE_API_URL}/${env.VITE_SEARCH_ENDPOINT}`;
    const k = keyword ? `*${keyword}*` : '**';
    const options = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "query": k,
            "filters": [
                {
                    "field": "indexname",
                    "key": "indexname",
                    "values": [
                        "projects"
                    ],
                    "type": "terms"
                }
            ],
            "page": 0,
            "size": "10"
        })
    };

    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data.items;
    } catch (error: any) {
        console.error(error);
        throw error;
    }
}

export async function fetchAttributes() {
    const env: any = import.meta.env;
    const url = `${env.VITE_API_URL}/${env.VITE_ATTRIBUTES_ENDPOINT}`;
    console.log(url);
    const options = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
    };

    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (!data?.attributes) throw Error("No attributes found in response");
        const mappedData = data.attributes.map((attribute: any) => {
            if (!attribute.fields) return;
            const attributeFields = attribute.fields.map((field: any) => {
                if (field.customData) {
                    if (field.customData.fieldVisibility) {
                        return {
                            ...field,
                            fieldVisibility: field.customData.fieldVisibility
                        }
                    } else {
                        return field;
                    }
                } else {
                    return field;
                }
            })
            return {
                ...attribute,
                fields: attributeFields
            }
        });
        return mappedData;
    } catch (error: any) {
        console.error(error);
        throw error;
    }
}